<template>
    <div class="cmp-search-history">
        <template v-if="context.isAuthenticated">
            <div class="td-radio background my-2 ml-1" v-if="context.isInRole(constants.Roles.FleetUserRole)">
                <label for="search-history-user">
                    <input type="radio" v-model="type" id="search-history-user" @change="changeType" value="user" />
                    <span>My History</span>
                </label>

                <label for="search-history-account">
                    <input type="radio" v-model="type" id="search-history-account" @change="changeType" value="account" />
                    <span>Fleet History</span>
                </label>
            </div>

            <div class="upgrade-link td-text-center" v-if="!context.isInRole(constants.Roles.FleetUserRole)">
                <a class="td-btn secondary" href="/accounts/fleet-upgrade" title="Upgrade your account to view all of your search history."><span>Upgrade your account</span> to view all of your search history</a>
            </div>

            <div class="pa-1" v-if="!loading && list.length == 0"><span class="td-banner warning no-icon slim">You do not have any seach history to display</span></div>
            <div v-else>
                <div class="pagination td-card border" v-if="context.isInRole(constants.Roles.FleetUserRole)">
                    <div class="td-text-subdued td-text-mice">
                        <i>{{ pagerText }}</i>
                    </div>
                    <div class="td-pagination-btns my-1 slim">
                        <button :disabled="!enablePrevious" :class="['secondary', 'previous', {'disabled': !enablePrevious}]"
                                @click.prevent="onPrevious"
                                title="Previous Page">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                        </button>
                        <button :class="['next', 'secondary', {'disabled': !enableNext}]"
                                @click.prevent="onNext"
                                title="Next"
                                :disabled="!enableNext">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                        </button>
                    </div>
                </div>
                <div class="td-card border" v-else>
                    <div class="td-text-subdued td-text-mice">
                        <i>Only displaying last 5 searches.</i>
                    </div>
                </div>
                <ul class="history-list">
                    <li v-for="item in list" :key="item.model.id" class="history-item">
                        <div class="location-details">
                            <p>
                                <icon type="solid" name="faLocationDot" aria-hidden="true"></icon>
                                <strong>{{ item.location }}</strong>
                            </p>
                            <span class="td-text-subdued td-text-mice">{{ item.details }}</span>
                        </div>
                        <div class="services-details">
                            <span>{{ item.service }}</span>
                        </div>
                        <div class="actions">
                            <button class="td-btn primary slim icon-left" @click="runSearch(item.model)">
                                <icon type="solid" name="faSearch" aria-hidden="true"></icon>Re-run Search
                            </button>
                        </div>
                    </li>
                </ul>
                <div class="pagination td-card border" v-if="context.isInRole(constants.Roles.FleetUserRole)">
                    <div class="td-text-subdued td-text-mice">
                        <i>{{ pagerText }}</i>
                    </div>
                    <div class="td-pagination-btns td-text-orange-dark my-1 slim">
                        <button :disabled="!enablePrevious" :class="['previous', {'disabled': !enablePrevious}]"
                                @click.prevent="onPrevious"
                                title="Previous Page">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                        </button>
                        <button :class="['next', {'disabled': !enableNext}]"
                                @click.prevent="onNext"
                                title="Next"
                                :disabled="!enableNext">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                        </button>
                    </div>
                </div>
                <div class="td-card border" v-else>
                    <div class="td-text-subdued td-text-mice">
                        <i>Only displaying last 5 searches.</i>
                    </div>
                </div>
            </div>
        </template>
        <signin-or-upgrade v-else>
            <template #heading>
                <h2>Search History</h2>
                <p>Automatically track your search history.</p>
            </template>
            <template #subheading>
                <h3>This is a free feature available to logged-in accounts</h3>
                <h4>Create a <strong>free account</strong> or <strong>login</strong> to access your previous searches!</h4>
            </template>
        </signin-or-upgrade>
    </div>
</template>

<script>import script from './SearchHistory';
    export default script;</script>
<style lang="less">
    @import "./SearchHistory.less";
</style>
